import React from 'react'
import Loader from './Loader'
import './loader.scss'

function CircleLoader({ loading }) {
  if (!loading) {
    return null
  }

  return (
    <div className="loader-container circle-loader">
      <Loader />
    </div>
  )
}

export default CircleLoader
